module.exports = __webpack_public_path__ + "static/media/Cake 600x600.eed21fc4.png";